import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { SessionContext } from './SessionContext.js';
import { Section, NOTES_MAX_CHARS } from '../Common.js';
import './NewAlias.css';

class NewAlias extends Component {
  static contextType = SessionContext;

  state = {
    siteName: '',
    siteUrl: '',
    privateNotes: '',
    handleSpamBy: -1,
    alertMeOfHeldMessages: true,
    hideFromMainView: false,
    showTip: true
  }

  async componentDidMount() {
    this.API = this.context.actions.getAPI();

    // Check if user has dismissed the tip
    const tipDismissed = localStorage.getItem('newAliasTipDismissed');
    if (tipDismissed === 'true') {
      this.setState({ showTip: false });
    }
  }

  dismissTip = () => {
    localStorage.setItem('newAliasTipDismissed', 'true');
    this.setState({ showTip: false });
  }

  handleInputChange = (field, value) => {
    this.setState({ [field]: value });
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!this.state.siteName.trim()) {
      toast.error('Site Name is required');
      return;
    }


    try {
      const aliasData = {
        site_name: this.state.siteName,
        custom_url: this.state.siteUrl,
        private_notes: this.state.privateNotes,
        alerts_enabled: this.state.alertMeOfHeldMessages,
        hidden: this.state.hideFromMainView,
        blacklist_action: this.state.handleSpamBy
      };

      const newAlias = await this.API.createAlias(aliasData);
      
      if (newAlias) {
        toast.success(`Alias created: ${newAlias.alias}@nslmail.com`);
        this.props.history.push('/aliases');
      }
    } catch (e) {
      toast.error('Error creating alias: ' + e.message);
      console.error(e);
    }
  }

  handleCancel = () => {
    this.props.history.push('/aliases');
  }

  render() {
    return (
      <div className="new-alias">
        <Section name="Create New Alias">
          {this.state.showTip && (
            <div style={{
              padding: '15px 20px',
              backgroundColor: '#f0f9ff',
              border: '1px solid #bae6fd',
              borderRadius: '6px',
              marginBottom: '20px',
              position: 'relative'
            }}>
              <button
                onClick={this.dismissTip}
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: '#0369a1',
                  padding: '0',
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  opacity: 0.7
                }}
                title="Dismiss tip"
                aria-label="Close tip"
              >
                ×
              </button>
              <p style={{ margin: '0 0 10px 0', fontSize: '15px', color: '#0369a1', paddingRight: '30px' }}>
                <strong><span role="img" aria-label="lightbulb">💡</span> Tip:</strong> Creating aliases is easier with browser tools!
              </p>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px', color: '#075985' }}>
                When you're browsing the web, these tools will automatically fill in the site name and URL for you:
              </p>
              <div style={{ fontSize: '14px', color: '#075985', display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                <a
                  href="/downloads/nslmail-extension-1.0.1.xpi"
                  style={{ color: '#0369a1', fontWeight: 'bold', textDecoration: 'none' }}
                >
                  <span role="img" aria-label="package">📦</span> Install Firefox Extension
                </a>
                <Link to="/bookmarklet" style={{ color: '#0369a1', fontWeight: 'bold' }}>
                  <span role="img" aria-label="bookmark">🔖</span> Install Bookmarklet
                </Link>
              </div>
            </div>
          )}

          <div className="card">
            <div className="card-content">
              <form onSubmit={this.handleSubmit}>
                <div className="form-group">
                  <label className="form-label" htmlFor="siteName">Site Name</label>
                  <input
                    type="text"
                    id="siteName"
                    className="form-input"
                    value={this.state.siteName}
                    onChange={(e) => this.handleInputChange('siteName', e.target.value)}
                    placeholder="Enter the name of the site"
                  />
                  <div className="form-help">The website or service this alias is for</div>
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="siteUrl">Site URL</label>
                  <input
                    type="text"
                    id="siteUrl"
                    className="form-input"
                    value={this.state.siteUrl}
                    onChange={(e) => this.handleInputChange('siteUrl', e.target.value)}
                    placeholder="https://www.example.com"
                  />
                  <div className="form-help">Optional website URL for reference</div>
                </div>

                <div className="form-group mb-6">
                  <label className="form-label" htmlFor="privateNotes">Private Notes</label>
                  <textarea
                    id="privateNotes"
                    className="form-input"
                    maxLength={NOTES_MAX_CHARS}
                    value={this.state.privateNotes}
                    onChange={(e) => this.handleInputChange('privateNotes', e.target.value)}
                    rows="3"
                    placeholder="Personal notes about this alias"
                  />
                  <div className="form-help">Optional notes for your reference</div>
                </div>

                <div className="form-group mb-6">
                  <label className="form-label" htmlFor="handleSpamBy">Handle Spam By</label>
                  <select
                    id="handleSpamBy"
                    className="form-input"
                    value={this.state.handleSpamBy}
                    onChange={(e) => this.handleInputChange('handleSpamBy', parseInt(e.target.value))}
                  >
                    <option value={-1}>Use Global Setting</option>
                    <option value={0}>Prefixing Subject Line</option>
                    <option value={1}>Deleting Message</option>
                  </select>
                  <div className="form-help">How to handle spam messages for this alias</div>
                </div>

                <div className="form-group mb-6">
                  <table className="form">
                    <tbody>
                      <tr>
                        <td><label htmlFor="checkbox_alerts">Alert me of held messages</label></td>
                        <td><input id="checkbox_alerts" type="checkbox" checked={this.state.alertMeOfHeldMessages} onChange={(e) => this.handleInputChange('alertMeOfHeldMessages', e.target.checked)} /></td>
                      </tr>
                      <tr>
                        <td><label htmlFor="checkbox_hidden">Hide from main view</label></td>
                        <td><input id="checkbox_hidden" type="checkbox" checked={this.state.hideFromMainView} onChange={(e) => this.handleInputChange('hideFromMainView', e.target.checked)} /></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="flex justify-center gap-4">
                  <button type="submit" className="btn btn-primary btn-lg">
                    Create Alias
                  </button>
                  <button type="button" className="btn btn-secondary btn-lg" onClick={this.handleCancel}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Section>
      </div>
    );
  }
}

export default NewAlias;